module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-cebrity-jennifer-lopez-6949a44a8cf0f9b36c45c34d3541b6ec.png";